import {
  BotConfiguration,
  BotEnvironmentData,
  BotMetadata,
  EnvironmentType
} from '@feedyou-ai/feedbot-schema'
import { omitLastChars } from './stringOperation'

const TEST_SUFFIX = '-test'

export const getProdBotId = (botId: string) => {
  return botId?.endsWith(TEST_SUFFIX) ? omitLastChars(botId, TEST_SUFFIX.length) : botId
}

export const isEnv = (
  type: EnvironmentType,
  envData: BotMetadata | BotConfiguration | BotEnvironmentData
) => {
  return envData.environmentType === type
}

export function isEnabled(envData: BotMetadata | BotConfiguration | BotEnvironmentData) {
  return envData.environmentEnabledStatus
}
